import { init } from "./init.js";
function AirstackProvider({
  children,
  apiKey,
  ...config
}) {
  init(apiKey, config);
  return children;
}
export {
  AirstackProvider
};
